import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '给你报告我们的2019：248位专家帮用户解决10056个问题';

const route: RouteConfig = {
  path: '/20200101ZBB',
  name: 'LHYZ',
  component: () => import('./Home.vue'),
  // redirect: '/2019FMXY/Welcome',
  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
